// Les Reels sont passés à React (js/react/ecrans/Reels.jsx).
//
// L'`IntersectionObserver` qui lance la vidéo visible et met les autres en
// pause est conservé tel quel : savoir quelle vidéo est à l'écran est une
// question de mise en page, pas d'état, et React n'a rien de mieux à proposer.
//
// L'ancienne version (d'avant React) a été retirée le 20 octobre 2026 —
// archivée hors du dépôt : ~/Desktop/koinonia-archive-code-retire-2026-10-20.zip.
import { vueReact } from "../react/pont.jsx";
import Reels from "../react/ecrans/Reels.jsx";

export const rendre = vueReact(Reels);
